import introJs from "intro.js";
import "intro.js/introjs.css";

export function startIntro(steps, options = {}) {
  const instance = introJs();

  instance.setOptions({
    disableInteraction: true,
    steps,
    nextLabel: "Tiếp theo",
    prevLabel: "Quay về",
    doneLabel: "Hoàn tất",
    ...options,
  });

  const updateStepCounter = () => {
    const currentStep = instance._currentStep + 1; 
    const totalSteps = steps.length;

    const introTooltipButtons = document.querySelector(".introjs-tooltipbuttons");
    if (introTooltipButtons) {
      let stepCounter = document.querySelector(".intro-step-counter");

      if (stepCounter) stepCounter.remove();

      stepCounter = document.createElement("div");
      stepCounter.className = "intro-step-counter";
      stepCounter.innerText = `${currentStep} / ${totalSteps}`;
      introTooltipButtons.insertBefore(stepCounter, introTooltipButtons.firstChild);
    }
  };
  instance.onafterchange(updateStepCounter);
  instance.onbeforechange(updateStepCounter);
  instance.setOption("dontShowAgain", true).start();
  return instance;
}
